import { render, staticRenderFns } from "./NoteBloc.vue?vue&type=template&id=566c3d2a"
import script from "./NoteBloc.vue?vue&type=script&lang=js"
export * from "./NoteBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports